import { html, cssManager } from '@design.estate/dees-element';

export const demo = () => html`
  <style>
    .demo-container {
      padding: 48px;
      background: ${cssManager.bdTheme('#f8f9fa', '#0a0a0a')};
      display: flex;
      flex-direction: column;
      gap: 32px;
    }

    .section {
      max-width: 800px;
      width: 100%;
      margin: 0 auto;
    }

    .section-title {
      font-size: 18px;
      font-weight: 600;
      margin-bottom: 8px;
      color: ${cssManager.bdTheme('#09090b', '#fafafa')};
    }

    .section-description {
      font-size: 14px;
      color: ${cssManager.bdTheme('#71717a', '#a1a1aa')};
      margin-bottom: 16px;
    }
  </style>

  <div class="demo-container">
    <div class="section">
      <div class="section-title">Video with Custom Controls</div>
      <div class="section-description">A video player with overlay controls, seeking, and volume adjustment.</div>
      <dees-video-viewer
        src="https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4"
        poster="https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/images/BigBuckBunny.jpg"
      ></dees-video-viewer>
    </div>

    <div class="section">
      <div class="section-title">Autoplay Muted</div>
      <div class="section-description">Video that autoplays muted, commonly used for previews.</div>
      <dees-video-viewer
        src="https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4"
        poster="https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/images/ElephantsDream.jpg"
        .autoplay=${true}
        .muted=${true}
      ></dees-video-viewer>
    </div>

    <div class="section">
      <div class="section-title">Native Controls</div>
      <div class="section-description">Video using browser-native controls instead of custom overlay.</div>
      <dees-video-viewer
        src="https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4"
        .showControls=${false}
      ></dees-video-viewer>
    </div>
  </div>
`;
